import React, { Component, useState, useEffect, useContext } from 'react';
import CustomDivComponent from "../components/divComponent";
import formData from '../lib/formsData.json'
import { postRequest, getUser, setVisitId, getVisitHistoryType, getVisitId, getVisitHistoryId } from "../Services/DataMode";
import UserContext from '../components/context';
import Form from 'react-bootstrap/Form'


function VisitHistory() {
    const context = useContext(UserContext);
    const [values, setValues] = useState({});
    const [hideInjuryInfo2, setInjuryInfo2] = useState(true);
    const [patientName, setPatientName] = useState('');

    useEffect(() => {
        postRequest('ws_webrtc/Telemed.asmx/getVisitHistory',
            { sKey: getUser(), iVisitId: getVisitHistoryId() },
            (response) => {
                // console.log(JSON.stringify(response.d));
                // console.log(response.d.visit_type,'visit_type');
                // console.log(response, 'history');
                setValues(response.d);
                setPatientName(response.d.first_name + ' ' + response.d.last_name);
                // Set hideInjuryInfo2 based on visit type - only show for non-MA visits
                setInjuryInfo2(response.d.InjuryTypeName1 == "");
            }, context)
    }, [])

    // Get the appropriate form data based on visit type
    const getFormData = () => {
        const visitType = getVisitHistoryType();
        if (visitType === 'MA') {
            return formData.ShowMAVisitHistory;
        }
        // For non-MA visits, filter out Injury Info 2 section if hideInjuryInfo2 is true
        const baseFormData = formData.ShowVisitHistory;
        const hasInjuryInfo2 = baseFormData.some(section => section.headerName === 'Injury Info 2');
        // Loop through all sections
        baseFormData.forEach(section => {
            if (section.headerName === 'Injury Info' && hasInjuryInfo2 && !hideInjuryInfo2) {
                section.headerName = 'Injury Info 1'; // Rename if Injury Info 2 is shown
            }
            if (section.headerName === 'Injury Info 1' && (!hasInjuryInfo2 || hideInjuryInfo2)) {
                section.headerName = 'Injury Info'; // Revert if Injury Info 2 is absent/hidden
            }
        });
        if (hideInjuryInfo2) {
            return baseFormData.filter(section => section.headerName !== 'Injury Info 2');
        }
        return baseFormData;
    };

    return (
        <>
            <div className="container-fluid" style={{ overflowX: 'hidden', width: '100 %', marginTop: 10, position: 'relative' }}>
                <div className="row" >
                    <div className='col-md-12 col-lg-12 col-xs-12 col-sm-12'>
                        <div className='row'>
                            <div className='col-12'>
                                <div>
                                    <Form.Label style={{ color: '#ff0000' }} >VISIT HISTORY: </Form.Label>
                                    <Form.Label style={{ color: '#ff0000', fontWeight: 'bold', marginLeft: 4 }} >{values.visit_Date}</Form.Label>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-12'>
                                <div>
                                    <Form.Label style={{ color: 'grey' }} >Physician Name: </Form.Label>
                                    <Form.Label style={{ color: 'grey', fontWeight: 'bold', marginLeft: 4 }} >{values.doc_name}</Form.Label>
                                </div>
                            </div>
                        </div>

                        <div>
                            <CustomDivComponent
                                data={getFormData()}
                                loadValues={values}
                                patientName={patientName}
                                hideInjuryInfo2={hideInjuryInfo2}
                            // hideInjuryInfo2={hideInjuryInfo2}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VisitHistory